module.exports = __webpack_public_path__ + "img/10.747cd93b.png";